import { Spinner } from "@nextui-org/react";
import type { ReactNode } from "react";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import useAuth from "@/services/useAuth";

import ChatbotFavorite from "./ChatbotFavorite";

export default function ChatbotFavoritePage() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  let pageContent: ReactNode;
  if (isAuthLoading) {
    pageContent = <Spinner />;
  } else if (!isAuthenticated) {
    pageContent = <AnonymousMarketing datakey="favorites" />;
  } else {
    pageContent = <ChatbotFavorite />;
  }

  return (
    <>
      <PageStaticMetaTags pageId="favoriteBots" data-testid="ChatbotFavorite-PageStaticMetaTags" />
      {pageContent}
    </>
  );
}
